import { AxiosResponse } from 'axios'

// realisations
import { http } from '../realisations/Http.realisation'

// types
import { GetUsersParams, GetUsersResponse } from '@/core/types/delivery-users.types'

export class DeliveryUsersRepository {
    getUsers(params: GetUsersParams): Promise<AxiosResponse<GetUsersResponse>> {
        return http.get('/order/api/v1/call-center/users', { params })
    }
}
